import React from 'react'
import styles from './Login.scss'
import { LoginModal } from 'common/styleguide/LoginModal'
import { LoginModalOverlay } from 'common/styleguide/LoginModalOverlay'
import { CTA } from 'common/styleguide/CTA'

export class Login extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      showLoginModalOverlay: false
    }
  }

  showOverlay = () => {
    this.setState({ showLoginModalOverlay: true })
  }

  hideOverlay = () => {
    this.setState({ showLoginModalOverlay: false })
  }

  render () {
    const { showLoginModalOverlay } = this.state

    return (
      <div className={styles.Login}>
        <h1>Login</h1>
        <p>Login Modal</p>
        <div className={styles.constrainWidth}>
          <LoginModal />
        </div>
        <p>Login Modal Overlay</p>
        <CTA inline onClick={this.showOverlay}>Launch Login Modal Overlay</CTA>
        {showLoginModalOverlay && <LoginModalOverlay onRequestClose={this.hideOverlay} />}
      </div>
    )
  }
}
